/* global __SHAREWELL_RELEASE__, __SHAREWELL_RUM_SAMPLE_RATE__ */

import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

const RELEASE = typeof __SHAREWELL_RELEASE__ === 'string' ? __SHAREWELL_RELEASE__ : 'unknown';
const SAMPLE_RATE = typeof __SHAREWELL_RUM_SAMPLE_RATE__ === 'number'
  ? __SHAREWELL_RUM_SAMPLE_RATE__
  : 1;
const PUBLIC_PATH_PATTERN = /^\/(?:$|fr$|es$|(?:fr\/|es\/)?(?:faq|pricing|privacy|terms)(?:\/|$)|(?:fr\/|es\/)?(?:occasions|guides|examples|research|blog)(?:\/|$))/i;

function deviceForViewport() {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  if (/iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent)) return 'tablet';
  if (typeof window !== 'undefined' && window.matchMedia('(max-width: 680px)').matches) return 'mobile';
  return 'desktop';
}

function connectionType() {
  const connection = typeof navigator !== 'undefined'
    ? navigator.connection || navigator.mozConnection || navigator.webkitConnection
    : null;
  return connection && typeof connection.effectiveType === 'string'
    ? connection.effectiveType
    : 'unknown';
}

function navigationType() {
  if (typeof performance === 'undefined' || typeof performance.getEntriesByType !== 'function') return 'unknown';
  const navigation = performance.getEntriesByType('navigation')[0];
  return navigation && typeof navigation.type === 'string' ? navigation.type : 'unknown';
}

function sendMeasurements(metrics) {
  if (!metrics.length || typeof window === 'undefined') return;

  const payload = JSON.stringify({
    page_path: window.location.pathname || '/',
    device: deviceForViewport(),
    connection: connectionType(),
    navigation_type: navigationType(),
    release: RELEASE,
    sample_rate: SAMPLE_RATE,
    metrics,
  });
  const endpoint = '/api/performance/web-vitals';

  try {
    if (typeof navigator.sendBeacon === 'function' && typeof Blob === 'function') {
      const accepted = navigator.sendBeacon(endpoint, new Blob([payload], { type: 'application/json' }));
      if (accepted) return;
    }
  } catch {
    // Fall through to fetch for browsers that reject a beacon payload.
  }

  if (typeof fetch === 'function') {
    fetch(endpoint, {
      method: 'POST',
      body: payload,
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      keepalive: true,
    }).catch(() => {});
  }
}

if (
  typeof window !== 'undefined'
  && typeof document !== 'undefined'
  && PUBLIC_PATH_PATTERN.test(window.location.pathname || '/')
  && (SAMPLE_RATE >= 1 || Math.random() < SAMPLE_RATE)
) {
  const metrics = [];
  let flushed = false;

  const record = metric => {
    if (!metric || !metric.name || !Number.isFinite(metric.value) || !metric.id) return;
    metrics.push({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
    });
  };

  const flush = () => {
    if (flushed) return;
    flushed = true;
    sendMeasurements(metrics);
  };

  onCLS(record);
  onFCP(record);
  onINP(record);
  onLCP(record);
  onTTFB(record);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  }, { once: true });
  window.addEventListener('pagehide', flush, { once: true });
}
